module.exports = __webpack_public_path__ + "static/media/pencil-alt.c58ba84c.svg";